const validateURL = (url: string): boolean => {
  let urlToTest = url;
  if (!/^https?:\/\//i.test(url)) {
    urlToTest = 'http://' + url;
  }

  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?' + // port
      '(\\/[-a-z\\d%_.~+]*)*' + // path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // fragment locator

  return !!pattern.test(urlToTest);
};

const validateTwitter = (url?: string): boolean => {
  if (!url) {
    return true;
  }
  if (!validateURL(url)) {
    return false;
  }
  let host: string;
  try {
    host = new URL(url.includes('://') ? url : 'http://' + url).host;
  } catch (e) {
    return false;
  }
  return host === 'twitter.com' || host.endsWith('.twitter.com');
};

const validateFacebook = (url?: string): boolean => {
  if (!url) {
    return true;
  }
  if (!validateURL(url)) {
    return false;
  }
  let host: string;
  try {
    host = new URL(url.includes('://') ? url : 'http://' + url).host;
  } catch (e) {
    return false;
  }
  return host === 'facebook.com' || host.endsWith('.facebook.com');
};

const validateGithub = (url?: string): boolean => {
  if (!url) {
    return true;
  }
  if (!validateURL(url)) {
    return false;
  }
  let host: string;
  try {
    host = new URL(url.includes('://') ? url : 'http://' + url).host;
  } catch (e) {
    return false;
  }
  return host === 'github.com' || host.endsWith('.github.com');
};

export { validateFacebook, validateGithub, validateTwitter };
